const ResumeData = {
    cvDate: "2026",

    links: {
        location: "Italy",
        mail: "mailto:kiansegantini@gmail.com",
        behance: "https://behance.net/kiansegantini",
        linkedin: "https://linkedin.com/in/kian-segantini",
    },

    sectionTitles: ["Introduction", "Education", "Languages", "Courses", "Books",
        "Experience", "Skills"],

    introduction: {
        text: "I'm Kian Segantini, a UX/UI designer and front-end developer focused on creating clear, functional, and visually refined digital experiences. I've worked across product design, web design, and digital projects, taking ideas from early concepts and user flows through to polished interfaces and functional implementations. My experience spans startups, open-source projects, and Web3, with a strong focus on combining design thinking with practical execution. I'm currently looking to grow through real-world projects, collaborations, and opportunities where I can contribute both creatively and technically.",
    },

    education: {
        cards: [
            {
                start: "2025",
                end: "2026",
                title: "West River Academy",
                subtitle1: "High School Diploma | GPA: 4.0",
                subtitle2: "California, USA",
            },
            {
                start: "2021",
                end: "2024",
                title: "IEXS",
                subtitle1: "High School",
                subtitle2: "Italy",
            },
        ]
    },

    languages: [
        { language: "Italian", level: "Native", percentage: 100 },
        { language: "English", level: "Native", percentage: 95 },
        { language: "Spanish", level: "Intermediate Level", percentage: 75 },
        { language: "Portoguese", level: "Beginner Level", percentage: 15 },
    ],

    courses: {
        cards: [
            {
                start: "Apr.",
                end: "2026",
                title: "H-ACK Hackathon",
                subtitle1: "H-Farm College",
                subtitle2: "Jaki Dale",
            },
            {
                start: "Nov.",
                end: "2024",
                title: "D/I Hackaton",
                subtitle1: "OpenMesh",
                subtitle2: "Ashton Hettiarachi",
            },
            {
                start: "Nov.",
                end: "2023",
                title: "AI Workshop",
                subtitle1: "Teach Me Wall Street",
                subtitle2: "Tyler Moulton",
            },
            {
                start: "Sep.",
                end: "2023",
                title: "BlockChain & Defi",
                subtitle1: "Teach Me Wall Street",
                subtitle2: "Annaline Dinkelmann",
            },
            {
                start: "May",
                end: "2024",
                title: "Summer of Bitcoin",
                subtitle1: "Summer of Bitcoin",
                subtitle2: "Adi Shankara",
            },
            {
                start: "Dec.",
                end: "2023",
                title: "CS50's Python",
                subtitle1: "Harvard Online",
                subtitle2: "Timothy R. James",
            },
        ]
    },

    books: {
        cards: [
            {
                start: "Oct.",
                end: "2024",
                title: "Atomic Habits",
                subtitle1: "James Clear",
                subtitle2: ""
            },
            {
                start: "Jan.",
                end: "2025",
                title: "Getting to Yes",
                subtitle1: "Roger Fisher & William Ury",
                subtitle2: ""
            },
            {
                start: "May",
                end: "2025",
                title: "Read People Like a Book",
                subtitle1: "Patrick King",
                subtitle2: ""
            },
            {
                start: "Nov.",
                end: "2023",
                title: "The Diary of a CEO",
                subtitle1: "Steven Bartlett",
                subtitle2: ""
            },
            {
                start: "Dec.",
                end: "2023",
                title: "Limitless",
                subtitle1: "Jim Kwik",
                subtitle2: ""
            },
        ]
    },

    experience: {
        cards: [
            {
                start: "Sept.",
                end: "2025",
                title: "Q/OMIT",
                subtitle1: "UX|UI Designer",
                subtitle2: "Q/OMIT is dedicated to enhancing focus, sleep, and recovery through an innovative invisible nose strip.",
                link: "/qomit"
            },
            {
                start: "2024",
                end: "2025",
                title: "Edenauts",
                subtitle1: "UX|UI Designer",
                subtitle2: "Edenauts is a gamified platform for self-mastery through daily challenges.",
            },
            {
                start: "2023",
                end: "2024",
                title: "StudyCrew",
                subtitle1: "Lead UX|UI Designer / Project Manager",
                subtitle2: "StudyCrew is an open-source platform fostering collaborative, accessible education.",
                link: "/studycrew"
            },
            {
                start: "May",
                end: "2024",
                title: "Summer of Bitcoin",
                subtitle1: "Web3 UX|UI Designer",
                subtitle2: "Summer of Bitcoin is a global internship introducing students to Bitcoin development.",
                link: "/summer-of-bitcoin"
            },
        ]
    },
    skills: [
        // Design & Prototyping
        { title: "Figma", percentage: 100 },
        { title: "Photoshop", percentage: 90 },
        { title: "Illustrator", percentage: 60 },
        { title: "Midjourney", percentage: 100 },
        { title: "Shopify", percentage: 80 },

        // Front-End Development
        { title: "HTML", percentage: 90 },
        { title: "CSS", percentage: 90 },
        { title: "React", percentage: 50 },

        // Productivity
        { title: "PowerPoint", percentage: 100 },
        { title: "Word", percentage: 100 },
        { title: "Excel", percentage: 80 },

        // Multimedia
        { title: "CapCut", percentage: 70 },

        // Other useful additions
        { title: "Notion", percentage: 90 },
    ]
};

export default ResumeData;